import React from 'react'

const formatPrice = (amount) => {
  return `$ ${(amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

const MechanicalSection = ({ report, allowViewPricing }) => {
  const mechanical = report && report.mechanical
  const panels = (mechanical && mechanical.panels) || []

  // Flatten all active items across every panel
  const items = panels.reduce((acc, panel) => {
    const panelItems = (panel && panel.items) || []
    return acc.concat(panelItems.filter(item => item && item.active))
  }, [])

  // Hide the whole section when there is no mechanical data / no items
  if (!mechanical || !items.length) return null

  const rate = mechanical.laborRateMechanical || 0
  const lineTotal = (item) => {
    if (typeof item.amount === 'number') return item.amount
    return (item.hours || 0) * rate
  }
  const categoryTotal = items.reduce((sum, item) => sum + lineTotal(item), 0)

  return (
    <div className='adas-detail__report-card'>
      <div className='adas-detail__report-header'>
        <div className='adas-detail__report-header-left'>
          <h3 className='adas-detail__report-title'>Mechanical</h3>
        </div>
        <div className='adas-detail__report-header-right'>
          <span className='adas-detail__meta-label'>Labor Rate: {formatPrice(rate)}/hr</span>
        </div>
      </div>

      <div>
        <div className='adas-detail__category-row'>Mechanical</div>

        {items.map((item, i) => (
          <div key={i} className='adas-detail__service-row'>
            <div className='adas-detail__service-name'>
              <span>{item.name || '—'}</span>
            </div>
            <div className='adas-detail__service-status'>
              <span className='adas-detail__meta-label'>Hours:</span>
              <span className='adas-detail__price-value'>{(item.hours || 0).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 2 })}</span>
            </div>
            {allowViewPricing && (
              <div className='adas-detail__service-price'>
                <span className='adas-detail__meta-label'>Price:</span>
                <span className='adas-detail__price-value'>{formatPrice(lineTotal(item))}</span>
              </div>
            )}
          </div>
        ))}

        {allowViewPricing && (
          <div className='adas-detail__service-row'>
            <div className='adas-detail__service-name'>
              <span className='adas-detail__price-value'>Mechanical Total</span>
            </div>
            <div className='adas-detail__service-status' />
            <div className='adas-detail__service-price'>
              <span className='adas-detail__price-value'>{formatPrice(categoryTotal)}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default MechanicalSection
